import { render, staticRenderFns } from "./NoSurvey.vue?vue&type=template&id=24b9a7c4&"
import script from "./NoSurvey.vue?vue&type=script&lang=js&"
export * from "./NoSurvey.vue?vue&type=script&lang=js&"
import style0 from "./NoSurvey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports